import { Box, Button, ButtonProps } from "@chakra-ui/react";
import { Tooltip } from "../../common/components/Tooltip";
import { FrameworkAgreementDto } from "../../autogen/bff-api";
import { useStartRefusal } from "./callOffAvailability";

export const PanelActionButton = ({
  framework,
  label,
  onClick,
  variant = "solid",
  startsMiniCompetition = false,
}: {
  framework: FrameworkAgreementDto;
  label: string;
  onClick: () => void;
  variant?: ButtonProps["variant"];
  startsMiniCompetition?: boolean;
}) => {
  const refusal = useStartRefusal(framework, { startsMiniCompetition });
  return (
    <Tooltip label={refusal} isDisabled={refusal === null}>
      <Box>
        <Button colorScheme="teal" variant={variant} size="sm" isDisabled={refusal !== null} onClick={onClick}>
          {label}
        </Button>
      </Box>
    </Tooltip>
  );
};
